/* SIZE-GUIDE.JS
   Fane-skift (Klassiske bleer / Buksebleer) til den delte størrelsesguide-
   widget (snippets/size-guide.liquid). Kører for ALLE ".size-guide-widget"-
   forekomster på siden ad gangen, scopet lokalt til hver widget (ikke
   afhængig af section.id eller andre side-unikke id'er), så den virker
   uanset hvor mange gange/steder widget'en bruges på samme side.

   Hver ".size-guide-widget" finder og styrer kun sine egne knapper/paneler via
   DOM-nærhed (closest/querySelector), uden et side-unikt id. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.size-guide-widget').forEach(function (widget) {
    if (widget.dataset.sizeGuideInit) return;
    widget.dataset.sizeGuideInit = 'true';

    var buttons = widget.querySelectorAll('.tab-button');
    var panels = widget.querySelectorAll('.tab-content');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = this.getAttribute('data-tab');

        buttons.forEach(function (b) { b.classList.remove('active'); });
        panels.forEach(function (p) { p.classList.remove('active'); });

        this.classList.add('active');
        var panel = widget.querySelector('[data-tab-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  });
});

/* Hurtigere sideskift: cirklerne linker til produktsiderne. Når musen/fingeren rører en cirkel, henter browseren
   siden i baggrunden (prefetch), så den er næsten klar, når der klikkes. Cirklen skifter også farve med det samme
   (.is-loading), så man kan se at klikket er registreret. */
(function () {
  var prefetched = {};
  function prefetch(url) {
    if (!url || prefetched[url] || url.charAt(0) === '#') return;
    prefetched[url] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
  }
  function itemFrom(e) { return e.target && e.target.closest ? e.target.closest('.size-item') : null; }
  ['mouseover', 'touchstart', 'focusin'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var item = itemFrom(e);
      if (item) prefetch(item.getAttribute('href'));
    }, { passive: true });
  });
  document.addEventListener('click', function (e) {
    var item = itemFrom(e);
    if (item && item.getAttribute('href') && item.getAttribute('href') !== '#') item.classList.add('is-loading');
  });
  /* Tilbage-knappen: ryd tilstanden, så cirklen ikke står farvet. */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.size-item.is-loading').forEach(function (el) { el.classList.remove('is-loading'); });
  });
})();
